module.exports = __webpack_public_path__ + "static/media/cloud-download.7341369d.svg";